import { useDialogButtonActionsBase } from '@pflegia/ui/hooks/dialog/use-dialog-button-actions-base';

import { ACCEPT, APPLY, DECLINE, UPDATE_APPLICATION_MATCH_STATUS } from '@shared/graphql/mutations';
import { GET_CONNECTIONS_BY_CANDIDATE_ID } from '@shared/graphql/operations/connections-by-candidate-id';
import { FIND_MATCH_FOR_JOB_POSITION } from '@shared/graphql/operations/find-match-for-job-position';

import { useMatchModalLogic } from './use-match-modal-logic';

export const useDialogButtonActions = (jobPositionId: string) => {
  const { handleClose } = useMatchModalLogic({ withJobIdAssertion: false });
  return useDialogButtonActionsBase({
    jobPositionId,
    queries: {
      // @ts-expect-error Enum and string clash
      findMatchForJobPosition: FIND_MATCH_FOR_JOB_POSITION,
      getCandidateConnections: GET_CONNECTIONS_BY_CANDIDATE_ID,
    },
    mutations: {
      accept: ACCEPT,
      apply: APPLY,
      decline: DECLINE,
      revokeMatch: UPDATE_APPLICATION_MATCH_STATUS,
    },
    callBacks: {
      handleClose,
    },
  });
};
